<template>
  <div class="nav-footer">
    <!-- 定宽布局 -->
    <div class="container">
      <!-- 左侧 导航区块 -->
      <div class="f-list">
        <h2>网站导航</h2>
        <a href="/">网站首页</a>
        <a href="javascript:;" @click="goAc1()">行业资讯</a>
        <!-- <a href="javascript:;" @click="goInfo()">关于我们</a> -->
        <a href="javascript:;" @click="goXy()">用户协议</a>
      </div>
      <!-- 中间  联系我们区块 -->
      <div class="f-info">
        <h2>联系我们</h2>
        <ul>
          <li>公司：南京掌电无限科技有限公司</li>
          <li>邮箱：1961628038@qq.com</li>
          <li>电话：13311281282</li>
          <li>地址：南京市秦淮区康馨花园1幢1号-2041</li>
          <li>
            <a href="https://beian.miit.gov.cn/#/Integrated/index"
              >备案号：苏ICP备20026540号</a
            >
          </li>
        </ul>
      </div>
      <!-- 右侧 关于我们区块 公司名 + 简介 -->
      <div class="f-jj">
        <!-- <img src="/imgs/logo.png" alt="" /> -->
        <p>
          经营范围包括许可项目：第二类增值电信业务；互联网信息服务；网络文化经营（依法须经批准的项目，经相关部门批准后方可开展经营活动，具体经营项目以审批结果为准） 一般项目：技术服务、技术开发、技术咨询、技术交流、技术转让、技术推广；组织文化艺术交流活动；广告设计、代理；广告发布（非广播电台、电视台、报刊出版单位）；动漫游戏开发；软件开发（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    // 语文
    goAc1() {
      this.$router.push("/ac1");
    },
    // 英语
    goAc2() {
      this.$router.push("/ac2");
    },
    // 数据
    goAc3() {
      this.$router.push("/ac3");
    },
    goAc4() {
      this.$router.push("/ac4");
    },
    // 跳转关于我们
    goInfo() {
      this.$router.push("/info");
    },
    // 跳转注册协议
    goXy() {
      this.$router.push("/xy");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.nav-footer {
  width: 100%;
  height: 250px;
  background: #292f32;
  // margin-top: 40px;
  .container {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // 左侧导航
    .f-list {
      h2 {
        font-size: 14px;
        color: #fff;
        margin-bottom: 15px;
      }
      // 导航区块
      a {
        display: block;
        width: 60px;
        height: 20px;
        font-size: 14px;
        color: #fff;
        margin: 17px 0;
      }
    }
    // 中间联系我们
    .f-info {
      h2 {
        font-size: 14px;
        color: #fff;
      }
      ul {
        li {
          font-size: 12px;
          color: #fff;
          margin: 15px 0;
          a {
            font-size: 12px;
            color: #fff;
          }
        }
      }
    }
    // 右侧简介
    .f-jj {
      width: 300px;
      //   height: 100%;
      text-align: center;
      img {
        width: 200px;
        height: 80px;
        margin: 0 auto;
        background-color: #fff;
      }
      P {
        // text-indent: 15px;
        font-size: 12px;
        color: #fff;
        margin: 15px auto;
        text-align: left;
      }
    }
  }
}
</style>
